<template>
    <div class="pay-success-container">
        <div class="info">
            <div class="t1">
                <svg style="vertical-align:middle;" t="1574154963539" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="3670" width="24" height="24">
                    <path
                            d="M0 512C0 229.235 229.235 0 512 0s512 229.235 512 512-229.235 512-512 512S0 794.765 0 512z m419.31 194.63a35.31 35.31 0 0 0 49.4 1.272L804.228 395.97a35.31 35.31 0 0 0-48.075-51.73L447.03 633.786 301.903 484.14a35.31 35.31 0 1 0-50.688 49.17l168.113 173.32z"
                            p-id="3671" fill="#005924"></path>
                </svg>
                <span style="vertical-align: middle;margin-left: 10px;"
                      class="tips-larger">{{$t("result.success")}}</span>
            </div>
            <div class="t1">
				<span style="vertical-align:middle;">
				<span style="vertical-align:middle;">{{$t("result.paymoney")}}<span
                        style="color: red;font-weight: bolder">{{order.orderMoney}}</span>{{$t("result.yuan")}}!</span>
				</span>
            </div>
            <pay-detail :item="payInfo"></pay-detail>
            <pay-detail :item="orderDetail"></pay-detail>
            <pay-detail :item="ticketInfo"></pay-detail>
        </div>

        <!-- <pre-page title="关 闭" @back="close"></pre-page> -->
    </div>
</template>
<script>
    import log from "utils/log"
    import util from "utils/util"
    import apiChooseFee from "api/choose-fee"
    import prePage from "components/pre-page/index"
    import payDetail from './comps/index'
    import { loadToken} from '@/utils/cache'

    export default {
        name: "pay_suc_qrcode",
        components: {
            prePage, payDetail
        },
        data() {
            return {
                order: {
                    orderMoney: 0,
                },
                payInfo: {
                    name: '支付信息',
                    details: []
                },
                orderDetail: {
                    name: '订单明细',
                    details: []
                },
                ticketInfo: {
                    name: '发票信息',
                    details: []
                },
                showTicketTips: false
            }
        },

        methods: {
            close() {
               window.close();
            },
            err() {
                this.$dialog.alert(this.$t("result.err"), '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                }).then(() => {
                    this.close()
                })
            },
            getModel(name, value, type = 'text') {
                return {
                    name: name,
                    value: value,
                    type: type,
                }
            }
        },
        mounted() {
        },
        created() {
            let token = loadToken()
            console.log(token)

            let orderNo = this.$route.query.order_no
            if (orderNo) {
                apiChooseFee.getOrderInfo({orderNo: orderNo}).then(res => {
                    let order = res.data
                    this.order.orderMoney = order.orderMoney
                    this.payInfo.details.push(this.getModel(this.$t("result.order.name"), order.mchName))
                    this.payInfo.details.push(this.getModel(this.$t("result.order.no"), order.orderNo))
                    order.orderDetailVOS.forEach(item => {
                        this.orderDetail.details.push(this.getModel(item.itemName, item.itemMoney, 'money'))
                    })
                    this.ticketInfo.details.push(this.getModel(this.$t("result.ticket.title"), order.ticketTitle))
                    this.ticketInfo.details.push(this.getModel(this.$t("result.ticket.idtype"), order.ticketNum))
                    this.ticketInfo.details.push(this.getModel(this.$t("result.ticket.email"), order.ticketEmail))
                
                    if (token!='' && order.isAutoOpenTicket==1) {
						this.showTicketTips = true;
					}
                })
            } else {
                this.err()
            }
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .info {
        padding: 5px;
        padding-top: 10px;
        height: calc(100% - 50px);
        overflow-y: auto;
    }

    /deep/ .tips-larger {
        font-size: 18px;
    }

    /deep/ .tips-larger, .tips-middle {
        font-weight: 600;
    }

    /deep/ .card-content {
        padding-top: 0px !important;
    }

    /deep/ .t1 {
        height: 40px;
        line-height: 40px;
        margin-left: 30%;
        text-align: left;
    }
</style>